import router from '@/layout/router/index.js'
import bus from '@/public/utils/bus.js'
import axios from 'axios'
// import { http } from '@/public/utils/http.js'
import store from '@/public/store/index.js'
import { ENV } from '@/public/config'
import { getToken } from '@/public/utils/token'
import { md5Http, collectApiMap } from '@/public/utils/common'
import localforage from 'localforage'

const Reason = {
  'TIMEOUT': 'TIMEOUT', // 延迟器
  'PAGEHIDE': 'PAGEHIDE', // 页面隐藏
  'ROUTE': 'ROUTE', // 路由
  'UNLOAD': 'UNLOAD', // 窗口关闭
  'PAGEOPEN': 'PAGEOPEN' // 页面显示
}

const eventId = performance.timeOrigin
let beginTime = performance.now()

const vNumber = 'v00000001' // 异常情况：用于找不到当前账号
let localCache = null // 异常情况：用于在 localforage 找不到数据问题

const pollTime = 2 // 秒 // 本地暂存频率
const pollUploadTime = 61 // 秒
let poll = null

let userStore = localforage.createInstance({ 'name': 'timeOnPage2' })

let canReport = true

let mouseXY = null
let oldMouseXY = null

let num = 0
let maxNum = 30 // 如果超过maxNum分钟没有移动鼠标, 则停止上报

// 事件
function initEvent () {
  if (!collectApiMap[ENV]) return

  resetBeginTime()

  // 路由跳转时上报
  router.afterEach(onRouteChange)

  // 窗口隐藏时上报
  document.addEventListener('visibilitychange', onPageHide, false)

  // 多开页签时，更新缓存数据中eventId
  try {
    updateEventId(eventId)
  } catch (e) {
    console.error('[time-on-page]', e)
  }

  // 启动自动上报(无事件触发时, 自动上报)
  createPoll()

  // 存储每次鼠标位置
  window.addEventListener('mousemove', mouseMoveEvent)

  // 每分钟检测一次检测是否移动，超过时间不移动则停止上报
  setInterval(isCanReport, 60000)

  // 定时上报缓存数据
  setInterval(async () => {
    let data = await getReport()
    data && data.length && upload(data)
  }, pollUploadTime * 1000)
}

// 过滤异常数据, 比如累计太久的
function filterError (data) {
  if (!Array.isArray(data)) {
    return data
  }

  return data.filter(item => {
    return item.timeOnPage && item.timeOnPage < pollUploadTime * 1000 * 5 // 累计10次以上的数据不上报
  })
}

// 本地先定时累计暂存(pollTime)，到达一定时间后走http上报
function report (option) {
  try {
    beginReport(option)
  } catch (e) {
    console.error('[time-on-page]', e)
  }
}

async function beginReport (option) {
  let now = performance.now()
  let begin = beginTime
  let duration = now - begin

  resetBeginTime()
  removePoll()

  if (option.reason !== Reason.PAGEHIDE) {
    createPoll()
  }

  if (!canReport) {
    return
  }

  let menu = url2menu(option.url)
  if (!menu) return

  let reportData = {
    eventId,
    menuId: menu.id,
    menuTitle: menu.$ptitle + ' ' + menu.$title,
    menuOpenId: menu.menuOpenTime,
    timeOnPage: duration,
    timeBegin: performance.timeOrigin + begin,
    timeEnd: performance.timeOrigin + now,
    ...option,
    accumulator: 1
  }

  // 本地定时器，相同菜单的，合并本地数据
  if (option.reason === Reason.TIMEOUT) {
    storeReport(reportData)
  } else {
    // 其他场景，立即上报
    mergeAndUpload(reportData)
  }
}

async function mergeAndUpload (data) {
  let reportList = await mergeMenuReport(data)
  upload(reportList)
}

// http上报
function upload (data) {
  let token = getToken()

  if (isOverSize(data)) {
    deleteReport()
    return
  }

  data = filterError(data)

  if (!data.length) {
    return
  }

  if (!token) return

  const baseUrl = collectApiMap[ENV] || collectApiMap['uat']
  let now = Date.now()
  axios({
    url: baseUrl + '?cts.erp.uploadWebTpLog',
    method: 'post',
    data: data,
    timeout: 5000,
    headers: {
      token,
      method: 'cts.erp.uploadWebTpLog',
      timestamp: now,
      sign: md5Http(token, now, data),
      'X-Env': ENV || 'uat'
    }
  }).then(() => {
    // 已上报的数据，删除当前缓存
    deleteReport()
  })
}

function isOverSize (data) {
  // let maxSize = 1024 * 5 // 5kb
  // return JSON.stringify(data).length >= maxSize
  return Array.isArray(data) && data.length >= 100
}

function mouseMoveEvent (e) {
  mouseXY = `${e.x},${e.y}`
  if (!canReport) {
    resetCanReport()
  }
}

function isCanReport () {
  if (mouseXY === oldMouseXY) {
    num += 1
    if (num > maxNum) {
      canReport = false // 如果超过maxNum分钟没有移动鼠标, 则不上报
    }
  } else { // 恢复上报
    resetCanReport()
  }
}

function resetCanReport () {
  oldMouseXY = mouseXY
  num = 0
  canReport = true
}

function url2menu (url) {
  let menu = store.state.menus[url]
  // let bakMenuId = window.__ERPMODULE__ ? window.__ERPMODULE__.id : ''

  // menu = menu || { id: bakMenuId }

  if (menu && menu.id) {
    let menuOpenTime = store.state.tagsView.logs[menu.id]
    return {...menu, menuOpenTime}
  } else {
    return null
  }
}

// 删除缓存上报记录
function deleteReport () {
  let key = getCurrentStoreKey()
  localCache = null
  userStore.removeItem(key)
}

// 获取缓存上报记录
async function getReport () {
  const key = getCurrentStoreKey()
  const data = await userStore.getItem(key)
  // 其他db缓存数据存储在userStore，检查数据格式是否正确
  if (!Array.isArray(data)) {
    deleteReport()
    return []
  }

  if (!data.every(item => item.hasOwnProperty('menuId') && item.hasOwnProperty('menuOpenId'))) {
    deleteReport()
    return []
  }
  return data
}

// 缓存定时器停留时长，同菜单累加
async function storeReport (data) {
  let key = getCurrentStoreKey()
  if (!key) return
  let reportList = await mergeMenuReport(data)
  localCache = reportList
  userStore.setItem(key, reportList)
}

async function mergeMenuReport (data) {
  let reportList = await getReport()
  reportList = reportList || localCache || []
  let index = reportList.findIndex(item => item.menuId === data.menuId && item.menuOpenId === data.menuOpenId)
  if (index > -1) {
    let cur = reportList[index]
    reportList[index].timeOnPage = Number(cur.timeOnPage) + Number(data.timeOnPage)
    reportList[index].timeEnd = data.timeEnd
    reportList[index].reason = cur.reason === data.reason ? cur.reason : `${cur.reason} + ${data.reason}`
    reportList[index].accumulator = cur.accumulator + 1 // 累加次数
  } else {
    reportList.push(data)
  }
  return reportList
}

function updateEventId () {
  userStore.keys().then(function(res) {
    res = res || []
    let userId = getCurrentUserId()
    let currUeserKeys = res.filter(key => key.indexOf(userId) === 0)
    currUeserKeys.forEach(key => updatedSpecEventId(key))
  })
}

function updatedSpecEventId(key) {
  userStore.getItem(key).then(function(res) {
    res = res || []
    userStore.removeItem(key)
    let currStoreKey = getCurrentStoreKey()
    userStore.setItem(currStoreKey, res)
  })
}

function getCurrentUserId () {
  const bakUserId = window.__ERPUSER__ ? window.__ERPUSER__.employeeNumber : null
  return store.state.user.employeeNumber || bakUserId || vNumber
}

function getCurrentStoreKey () {
  return getCurrentUserId() + '@' + eventId
}

function createPoll () {
  poll = window.setTimeout(onTimeout, pollTime * 1000)
}

function removePoll () {
  window.clearInterval(poll)
}

function resetBeginTime () {
  beginTime = performance.now()
}

function getHash () {
  return router.currentRoute.meta.tag
}

// function onPageUnload () {
//   report({reason: Reason.UNLOAD, url: getHash(), async: false})
// }

function onPageHide() {
  const state = document.visibilityState
  if (state === 'hidden') {
    report({reason: Reason.PAGEHIDE, url: getHash()})
  } else {
    resetBeginTime()
    removePoll()
    createPoll()
    bus.$emit('WEBSOCKET_PING')
  }
}

function onRouteChange (to, from) {
  report({reason: Reason.ROUTE, url: from.meta.tag})
  setTimeout(() => {
    onPageOpen(to.meta.tag)
  }, 2000)
}

function onTimeout () {
  report({reason: Reason.TIMEOUT, url: getHash()})
}

function init () {
  setTimeout(() => {
    initEvent()
  }, 2000)
}

function onPageOpen (url) {
  let token = getToken()

  if (!token) return

  if (!collectApiMap[ENV]) return

  const baseUrl = collectApiMap[ENV] || collectApiMap['uat']
  let now = performance.now()
  let begin = beginTime

  let menu = url2menu(url)
  if (!menu) return

  let data = [
    {
      eventId,
      menuId: menu.id,
      menuTitle: menu.$ptitle + ' ' + menu.$title,
      menuOpenId: menu.menuOpenTime,
      timeOnPage: 0,
      timeBegin: performance.timeOrigin + begin,
      timeEnd: performance.timeOrigin + now,
      reason: 'PAGEOPEN',
      url
    }
  ]
  axios({
    url: baseUrl + '?cts.erp.uploadWebTpLog',
    method: 'post',
    data,
    timeout: 5000,
    headers: {
      token,
      method: 'cts.erp.uploadWebTpLog',
      timestamp: Date.now(),
      sign: md5Http(token, Date.now(), data),
      'X-Env': ENV || 'uat'
    }
  })
}

bus.$once('APP_LOADED', init)




// WEBPACK FOOTER //
// ./src/layout/layout/setup/time-on-page.js